<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data: function() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
html {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

*, *:before, *:after {
  -webkit-box-sizing: inherit;
  -moz-box-sizing: inherit;
  box-sizing: inherit;
}

:root {
 --c-greenish: #00D8BC;
 --c-link-blue: #009BFF;
 --c-button-blue: #3F51F2;
 --c-hover-blue: #2136FF;
 --c-deep-blue: #252F8E;
 --c-dark-blue: #1E2566;
 /*--c-dark-blue-dimmer: rgba(30, 37, 102, 0.6);*/
 --c-yellow: #FFD200;
 --c-orange: #FF9000;
 --c-red: #DB4B68;
 --c-torquoise: #00D2DE;
 --c-green: #51E06B;
 --c-olive: #75D74A;
 --c-purple: #C660D6;
 --c-viloet: #6A4DFF;
 --c-white-grey: #F6F8FC;
 --c-soft-grey: #EDF1FA;
 --c-light-grey: #E6EBF7;
 --c-bright-grey: #E6E8EE;
 --c-medium-grey: #D5D8E2;
 --c-medium-grey-menu-divider: rgba(213, 216, 226, 0.1);
 --c-greyish: #AEB4CB;
 --c-deep-grey: #7882A8;
 --c-dark-grey: #555F84;
 --c-red: #ff0000;

 --g-blue: linear-gradient(90deg, rgba(30,37,102,1) 0%, rgba(63,81,242,1) 50%);
 --g-ai-plus: linear-gradient(135deg, rgba(0,216,188,1) 0%, rgba(0,155,255,1) 50%);
 --g-ai: linear-gradient(135deg, rgba(198,96,214,1) 0%, rgba(106,77,255,1) 50%);
 --g-grey: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(240,243,250,1) 50%);
 --g-green: linear-gradient(135deg, rgba(0,216,188,1) 0%, rgba(0,155,255,1) 50%);

  --c-reference-data: var( --c-button-blue);
  --c-probe-data: var( --c-torquoise);

  --std-box-shadow: 0 0 30px rgba(37,47,142, 0.1);

  --c-scrollbar-color: #E4E7F2;
  --c-scrollbar-hover-color: var(--c-medium-grey);

  --sidebar-width: 460px;
  --infobar-width: 320px;

  scrollbar-color: var(--c-scrollbar-color) transparent;

  --context-menu-entry-height: 48px;

  --tr-default-height: 55px;
}

@font-face {
  font-family: 'BioSans';
  src: url('@/assets/fonts/bio_sans_regular.otf');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: 'BioSans';
  src: url('@/assets/fonts/bio_sans_semi_bold.otf');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'BioSans';
  src: url('@/assets/fonts/bio_sans_bold.otf');
  font-weight: 700;
  font-style: normal;
}

body {
  background: var(--g-grey);
  background-size: contain;
  background-attachment: fixed;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}

a:link, a:visited {
  text-decoration: none;
  color: var(--c-link-blue);
}

.hyphenate {
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
  -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
          hyphens: auto;
}

#app {
  font-family: BioSans, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select:none;
  text-align: center;
  color: var(--c-dark-blue);
  font-weight: 300;
}

.nowrap {
  white-space: nowrap;
}

.icon-button {
  min-width: 40px;
  min-height: 40px;
  cursor: pointer;
}

.icon-button.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

button {
  all: unset;
  cursor: pointer;
}

button.button {
  height: 34px;
  border-radius: 7px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 11px;
  padding: 0 20px;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
}

button.button.tall {
  height: 54px;
  font-size: 12px;
}
button.button.mediumsize {
  height: 44px;
}
button.button.warning {
  background: var(--c-red);
  color: #fff;
  border-radius: 7px;
}

button.button.primary {
  background: var(--c-button-blue);
  border: 1px solid var(--c-button-blue);
  color: #fff;
  height: 52px;
}

button.button.primary:hover {
  background: var(--c-hover-blue);
}

button.button.ghost {
  outline: 1px solid var(--c-button-blue);
  color: var(--c-button-blue);
}

button.button.ghost.active {
  background: var(--c-button-blue);
  color: #fff;
}

button::not(:disabled).button.ghost:hover {
    outline: 2px solid var(--c-button-blue);
    outline-offset: -1px;
}

button.button.ghost.active:hover {
   background: var(--c-hover-blue);
   color: #fff;
}

button.button.ghost.tall {
  height: 52px;
}
button.button.short {
  height: 23px;
}

button.button.plain {
  text-transform: none;
  color: var(--c-button-blue);
  font-weight: normal;
  font-size: 12px;
}

button.button.rounded {
  border-radius: 24px;
}
button.button.mediumsize {
  height: 44px;
}
button.button.raw {
  color: var(--c-button-blue);
}

button.button:disabled, button.button.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-group {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
}
.button-group .button {
  flex-grow: 1;
  margin-right: 10px;
}
.button-group .button:last-child {
  margin-right: 0;
}
/* dimmer */

.dimmer {
    position: relative;
    transition: all 1s;
}

.dimmer:after {
    content: '\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    background: var(--c-dark-blue);
    opacity: 0.6;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
}

/* --- HEADLINES */

h1 {
  font-weight: 500;
}
h1.underline, h2.underline {
  position: relative;
  padding: 20px;
  width: fit-content;
  margin-bottom: 30px;
}
h1.underline {
  padding: 40px 10px 20px 20px;
}
h1.underline::after, h2.underline::after {
  content: "";
  position:absolute;
  bottom: 0;
  left:50%;
  transform:translate(-50%,-50%);
  text-align:center;
  width: 60px;
  height: 2px;
  background-color: var(--c-greenish);
}
h1.underline.left, h2.underline.left {
  text-align: left;
}
h1.underline.left::after {
  left:0;
  transform:translate(20px,-50%);
}

h2 {
  font-weight: 500;
}

h2.underline {
  padding: 0 0 20px 0;
}

h2.underline.left::after {
  left:0;
  transform:translate(0,-50%);
}

h2.underline.ai.left::after {
  background-color: var(--c-purple);
}

h3 {
  font-weight: 500;
}

/* --- hr */

hr.sidebar {
  height: 1px;
  width: 460px;
  border-top: 1px solid var(--c-bright-grey);
  border-bottom: none;
  border-left: none;
  border-right: none;
  transform: translateX(-40px);
}

/* --- FORMS */

form {
  text-align: left;
}
fieldset {
  all: unset;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 0 0 0 1px;
}

label {
  font-size: 12px;
  color: var( --c-greyish);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  display: block;
  margin-bottom: 10px;
}

.dot {
    width: 6px;
    height: 6px;
    background: var(--c-deep-blue);
}

.dot.large {
    width: 10px;
    height: 10px;
}

/* Item Collection / Lists */

.item-collection ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.item-collection li {
    display: flex;
    flex-direction: row;
    align-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 7px;
    border: 1px solid var(--c-bright-grey);
    box-shadow: var(--std-box-shadow);
    padding: 20px 40px;
    cursor: pointer;
    margin-bottom: 20px;
    font-size: 14px;
    height: 108px;
    position: relative;
}
.item-collection li div.name {
    font-weight: 500;
    text-align: left;
}
.item-collection li div.name .headline-badge {
  transform: translate(0px, -4px);
}
.item-collection li div.date {
  max-width: 120px;
}
.item-collection li:hover {
    background-color: var(--c-lightgrey);
}
.item-collection li.header {
  background: #F2F4FA;
  border: 1px solid #E6EBF7;
  box-shadow: none;
  height: 48px;
  font-weight: 500;
}
.item-collection li.header > div {
  min-height: 20px;
  display: flex;
  align-items: center;
  color: #000;
}
.item-collection li.header > div.active {
  font-weight: 700;
}
.item-collection li.header > div.total-value {
  justify-content: end;
}

.item-collection > li div {
    flex-grow: 1;
    flex-basis: 0;
    text-align: left;
}
.item-collection > li div.icon {
    flex-grow: 0;
    padding-right: 20px;
}
.item-collection .actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.item-collection .actions > * {
    margin-right: 20px;
}
.item-collection .actions > *:last-child {
    margin-right: 0;
}

.context-menu-dots {
  min-width: 40px;
  max-width: 40px;
}
.item-collection li > div {
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}

.item-collection li > div:nth-child(1) {
  min-width: 5%;
  max-width: 5%;
  text-overflow: initial;
  overflow: visible;
}
.item-collection li > div:nth-child(2) {
  min-width: 25%;
  max-width: 25%;
  overflow: visible;
}
.item-collection li > div:nth-child(3) {
  min-width: 15%;
  max-width: 15%;
}
.item-collection li > div:nth-child(4) {
  min-width: 10%;
  max-width: 10%;
}
.item-collection li > div:nth-child(5) {
  min-width: 20%;
  max-width: 20%;
}
/* .item-collection li > div:nth-child(6) {
  min-width: 20%;
  max-width: 20%;
} */

.item-collection li > div:last-child {
  flex-grow: 1;
}

.item-collection li button {
  margin: 0;
}

.button-progress-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
}

/* List badges */

.list-badge {
  background-repeat: no-repeat;
  background-position: 0 10px;
}
.list-badge-favorite {
  background-size: 73.64px 16px;
  background-image: url("data:image/svg+xml;base64,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")
}
.list-badge-default {
  background-size: 60.637px 16px;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiAkJCQvR2VuZXJhbFN0ci8xOTY9QWRvYmUgSWxsdXN0cmF0b3IgMjcuNi4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNjAuNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjAuNiAxNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6IzI1MkY4RTt9DQoJLnN0MXtmaWxsOiNGRkZGRkY7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01Mi42LDE2SDBWMGg1Mi42YzQuNCwwLDgsMy42LDgsOFM1Ny4xLDE2LDUyLjYsMTZ6Ii8+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTEuNyw1LjJoMS42YzEuNywwLDIuOCwwLjgsMi44LDIuN2MwLDEuOS0xLjEsMi44LTIuNywyLjhoLTEuN1Y1LjJ6IE0xMy4yLDkuNWMwLjgsMCwxLjQtMC4zLDEuNC0xLjYNCgkJYzAtMS4zLTAuNi0xLjYtMS40LTEuNmgtMC4xTDEzLjIsOS41TDEzLjIsOS41eiIvPg0KCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNy45LDUuMmgzLjV2MS4yaC0yLjF2MC45aDEuOHYxLjJoLTEuOHYxaDIuMnYxLjJoLTMuNlY1LjJ6Ii8+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTIzLjUsNS4ySDI3djEuMmgtMi4xdjFoMS44djEuMmgtMS44djJoLTEuNVY1LjJ6Ii8+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTI5LjUsNS4yaDEuOGwxLjcsNS41aC0xLjVsLTAuMy0xLjJoLTEuNWwtMC4zLDEuMmgtMS41TDI5LjUsNS4yeiBNMjkuOCw4LjRoMUwzMC43LDgNCgkJYy0wLjEtMC41LTAuMy0xLjItMC40LTEuN2gwYy0wLjEsMC42LTAuMywxLjItMC40LDEuN0wyOS44LDguNHoiLz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMzQuMiw4VjUuMmgxLjV2M2MwLDEsMC4zLDEuMywwLjgsMS4zYzAuNiwwLDAuOC0wLjQsMC44LTEuM3YtM2gxLjRWOGMwLDEuOS0wLjcsMi44LTIuMiwyLjgNCgkJQzM0LjksMTAuOCwzNC4yLDkuOSwzNC4yLDh6Ii8+DQoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTQwLjcsNS4yaDEuNXY0LjNoMi4xdjEuMmgtMy41VjUuMnoiLz4NCgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNNDYuMSw2LjRoLTEuNVY1LjJINDl2MS4yaC0xLjV2NC4zaC0xLjVWNi40eiIvPg0KPC9nPg0KPC9zdmc+DQo=")
}

/* Loading spinner */

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* flex modifiers */

.flex {
    display: flex;
}
.flex.horizontal {
    flex-direction: row;
}
.flex.vertical {
    flex-direction: column;
}
.flex.vertical.full-height {
    align-content: space-between;
    height: 100%;
}


/* Scroll Container */

.scrollable-container {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  /* for Firefox */
  min-height: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  padding-right: 10px;
}

.scrollable-container.main {
  padding: 20px 60px 0 80px;
}

.scrollable-container.sidebar {
  /* padding: 0 30px 0 0; */
}

/* Scrollbar */

::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-scrollbar {
  background: transparent;
  width: 10px;
  height: 20px;
}

/* ::-webkit-scrollbar:hover {
    background-color: #111;
} */
::-webkit-scrollbar-thumb {
  background: var(--c-scrollbar-color);
  border-radius: 16px;
  width: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--c-scrollbar-hover-color);
}

/* Dev Info */

.dev-info {
  position: fixed;
  top: 10px;
  left: 10px;
  font-size: 10px;
  color: var(--c-dark-grey);
  text-align: left;
}

@media screen and (max-width: 1650px) {

  .scrollable-container.main {
    padding: 20px 20px 0 20px;
  }
  .button-progress-wrapper {
    max-width: 120px;
    min-width: 120px;
  }
  li button.button {
    height: 28px;
    font-size: 10px;
    padding: 0 10px;
    max-width: 100px;
  }
  .item-collection li {
    padding: 20px 20px;
  }
}

@media screen and (max-width: 1500px) {
  nav.main {
    display: none !important;
  }
  .main-header {
    padding-left: 24px !important;
    padding-right: 30px !important;
  }
}


</style>
